/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_Cash_RegisterInputs */

const vi_einvoice_settings_cash_register = /** @type {(inputs: Einvoice_Settings_Cash_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 — Máy tính tiền`)
};

/**

* @param {Einvoice_Settings_Cash_RegisterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_cash_register = /** @type {((inputs?: Einvoice_Settings_Cash_RegisterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_Cash_RegisterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_cash_register(inputs)
});